<template>
  <div>
    <section id="page-title">
            <div class="container clearfix">
                <h1 data-animate="fadeInUp">2014 WINTER</h1>
                <span data-delay="300" data-animate="fadeInUp">Winter Festival 2014</span>
            </div>
        </section>
         <section id="content">
            <div class="content-wrap">
                <div class="container clearfix">
                    <!-- Portfolio Filter
============================================= -->
                    <!-- #portfolio-filter end -->
                    <div class="clear"></div>
                    <!-- Portfolio Items
============================================= -->
                    <div id="portfolio" class="portfolio-masonry clearfix">
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/1winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/1winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/1winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/1winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/2winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/2winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/3winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/3winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/4winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/4winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/5winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/5winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/6winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/6winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/7winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/7winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/8winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/8winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/9winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/9winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/10winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/10winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/11winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/11winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/12winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/12winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/13winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/13winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/14winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/14winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/15winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/15winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/16winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/16winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/17winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/17winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/18winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/18winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/19winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/19winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/20winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/20winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/21winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/21winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/22winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/22winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2014">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2014/thumbs/23winter2014.png" alt="Winter 2014 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2014/23winter2014.jpeg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <!--Winter 2014 end-->

                        <!-- Portfolio Script
============================================= -->
                        <!--<script type="text/javascript">
                            
                        </script>-->
                        <!-- Portfolio Script End -->
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>
<script>
  export default {
    name: "2014spring",
    components:{
    },
    mounted(){
        jQuery(window).load(function() {

            var $container = jQuery('#portfolio');

            $container.isotope({
                transitionDuration: '0.65s'
            });

            jQuery('#portfolio-filter a').click(function() {
                jQuery('#portfolio-filter li').removeClass('activeFilter');
                jQuery(this).parent('li').addClass('activeFilter');
                var selector = $(this).attr('data-filter');
                $container.isotope({
                    filter: selector
                });
                return false;
            });

            jQuery('#portfolio-shuffle').click(function() {
                $container.isotope('updateSortData').isotope({
                    sortBy: 'random'
                });
            });

            jQuery(window).resize(function() {
                $container.isotope('layout');
            });

        });
    }
  }
</script>
